import { Entry } from 'contentful';

import { TypeBlogPostSkeleton } from '../../../interfaces/contentful';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { Container, ContainerVariants } from '../../Container/Container';
import { Heading } from '../../Heading/Heading';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { BlogPreviewCard } from '../BlogPreviewCard/BlogPreviewCard';
import { getCurrentRegion } from '../BlogPreviewCard/helpers/getCurrentRegion';
import { twMerge } from 'tailwind-merge';

interface IProps {
  blogPostItems: Entry<TypeBlogPostSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
  className?: string;
  containerVariant?: ContainerVariants;
  linkTo: string;
  linkToText?: string;
  showCountry?: boolean;
  speciesId?: string;
  regionId?: string;
  placeName?: string;
}

export const BlogPostSection = ({
  blogPostItems,
  className,
  containerVariant = 'default',
  linkTo,
  linkToText = 'See related posts',
  showCountry = false,
  speciesId,
  regionId,
  placeName,
}: IProps) => (
  <Container
    variant={containerVariant}
    className={twMerge('mt-sm flex flex-col items-center gap-6', className)}
  >
    <div className="flex w-full flex-col sm:mr-auto sm:w-1/2">
      <Heading as="h3" className="m-0">
        Fishbrain blog
      </Heading>
      <Text>
        Learn where to fish, when to fish, and top tips from our anglers to help you land that
        personal best
      </Text>
    </div>

    {blogPostItems.map(blogPost => {
      const {
        slug,
        title: blogPostTitle,
        postDescription,
        subjectTags,
        species,
        headerImage,
        category,
        publishDate,
        countryData,
        regionData,
      } = blogPost.fields;
      const _id = blogPost.sys.id;
      const imageUrl = headerImage?.fields.file?.url;
      const categorySlug = category?.fields.slug;
      const selectedRegion = regionId
        ? getCurrentRegion({ regionList: regionData, regionId: regionId.toUpperCase() })
        : undefined;

      return categorySlug ? (
        <BlogPreviewCard
          key={_id}
          imageUrl={imageUrl}
          categorySlug={categorySlug}
          blogPostSlug={slug}
          blogPostTitle={blogPostTitle}
          blogPostDescription={postDescription}
          blogTags={subjectTags}
          species={species || undefined}
          publishDate={publishDate}
          country={showCountry ? countryData : undefined}
          speciesId={speciesId}
          selectedRegion={regionId ? selectedRegion : undefined}
          placeName={placeName}
        />
      ) : (
        <></>
      );
    })}
    <InternalLink
      variant="textPrimaryDarkBg"
      to={linkTo}
      className="mb-4 flex gap-2 bg-sea-foam p-4"
    >
      {linkToText} <ArrowRightIcon size={20} />
    </InternalLink>
  </Container>
);
